"use client";
import React from "react";

interface ChallengeCardProps {
  title: string;
  badgeText: string;
  badgeColor: "blue" | "green";
  progressPercentage: number;
  progressColor: "blue" | "green";
  description: string;
  iconUrl?: string;
}

const ChallengeCard: React.FC<ChallengeCardProps> = ({
  title,
  badgeText,
  badgeColor,
  progressPercentage,
  progressColor,
  description,
  iconUrl,
}) => {
  const getBadgeClasses = () => {
    const baseClasses =
      "gap-1 self-stretch py-0.5 pr-2.5 pl-2 text-sm font-medium leading-none text-center whitespace-nowrap rounded-full border border-solid";

    if (badgeColor === "blue") {
      return `${baseClasses} text-blue-700 bg-sky-50 border-sky-200`;
    } else {
      return `${baseClasses} text-emerald-700 bg-emerald-50 border-emerald-200`;
    }
  };

  const getProgressColorClass = () => {
    return progressColor === "blue" ? "bg-blue-600" : "bg-green-500";
  };

  return (
    <article className="flex flex-col justify-center p-5 mt-6 w-full bg-white rounded-xl border border-solid shadow-sm border-[color:var(--Colors-Border-border-secondary,#EAECF0)] min-w-[216px]">
      <div className="flex gap-6 items-center w-full">
        <div className="flex-1 shrink self-stretch my-auto w-full basis-0 min-w-60">
          <div className="w-full">
            <div className="w-full">
              <div className="flex gap-1 items-start w-full">
                {iconUrl && (
                  <img
                    src={iconUrl}
                    alt="Challenge icon"
                    className="object-contain shrink-0 rounded-md aspect-square w-[25px]"
                  />
                )}
                <h3 className="flex-1 shrink text-base font-semibold text-gray-900 basis-[18px]">
                  {title}
                </h3>
                <span className={getBadgeClasses()}>{badgeText}</span>
              </div>
              <div className="flex gap-3 items-center mt-3 w-full">
                <div className="flex-1 shrink self-stretch my-auto w-full rounded-lg basis-0 min-w-60">
                  <div className="flex flex-col items-start bg-gray-200 rounded-full">
                    <div
                      className={`flex shrink-0 h-2 ${getProgressColorClass()} rounded-full`}
                      style={{ width: `${progressPercentage}%` }}
                    />
                  </div>
                </div>
              </div>
              <p className="gap-1 mt-3 w-full text-sm leading-none text-black">
                {description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default ChallengeCard;
